import React from 'react';
import { Link } from 'react-router-dom';

import config from '@config/config';
import {
  EXTENDED_SIDEBAR_WIDTH,
  COLLAPSED_SIDEBAR_WIDTH,
} from '@modules/common/components/Sidebar/SidebarWrapper/const';
import { ROOT_PATH } from '@src/constants/paths/internal';

type Props = {
  sidebarCollapsed: boolean;
};

function SidebarLogo({ sidebarCollapsed }: Props) {
  return (
    <div
      className="sidebar-logo content-center"
      style={{
        ...LOGO_STYLE,
        width: sidebarCollapsed ? COLLAPSED_SIDEBAR_WIDTH : EXTENDED_SIDEBAR_WIDTH,
      }}
    >
      <Link to={ROOT_PATH} style={{ height: '100%' }}>
        <img
          src={sidebarCollapsed ? config.collapsedLogo : config.logo}
          className="logo"
          alt="Logo"
        />
      </Link>
    </div>
  );
}

export default SidebarLogo;

const LOGO_STYLE = {
  background: `${() => config.sidebarColor} !important`,
  transition: 'width 0.3s, left 0.3s',
};
